import React, { Dispatch, SetStateAction } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { generateResponsiveStyle } from "../utils/modalStyle";
import moment from "moment";

type props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    details: any;
};

const EmailLeadMessage = ({ open, setOpen, details }: props) => {
    const style = generateResponsiveStyle();

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="modal_title">
                    <Typography id="modal-modal-title" component="h2">Lead messages</Typography>
                    <CloseIcon className="cross_icn_logout" onClick={() => setOpen(false)} />
                </div>
                <div className="modal_body">
                    <div className="control_group">
                        <Typography className="custom_label">Message</Typography>
                        <div className="msg_box">
                            {details?.length ? (
                                details?.map((item: any, index: number) => {
                                    return (
                                        <div className="lead_modal_div" >
                                            <p>{item?.message || ''}</p>
                                            <span className="msg_span" >{item?.createdAt ? moment(item?.createdAt).format("LLL") : ""}</span>
                                        </div>
                                    )
                                })

                            ) : ("No message found")}
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default EmailLeadMessage;
